import { Space } from 'antd';
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import langageApi from '../../api/language';

const Language = (props) => {
  const { record, showLanguageModal } = props;

  var filter = {
    page: 1,
    limit: 1000,
    keyword: '',
    filter_name: ['status'],
    filter_value: [1],
    order_by: 'id',
    order_dir: 'DESC',
  };
  const fetchLanguages = async () => {
    const response = await langageApi.getAll(filter);
    return response.data;
  };
  const {
    isPending,
    error,
    data: languages,
  } = useQuery({
    queryKey: ['languages'],
    queryFn: fetchLanguages,
  });

  if (isPending) return 'Loading...';

  if (error) return 'An error has occurred: ' + error.message;
  return (
    <Space>
      {languages &&
        languages.length > 0 &&
        languages.map(
          (item) =>
            !item.is_default && (
              <div
                key={item.id}
                style={{
                  display: 'inline-block',
                  cursor: 'pointer',
                }}
                onClick={() => showLanguageModal(record, item)}
              >
                <img
                  src={
                    require(`../../assets/img/country/${item?.code}.png`)
                      .default
                  }
                  className="img-job-detail"
                  style={{
                    width: '25px',
                    borderRadius: '5px',
                  }}
                  alt=""
                />
              </div>
            )
        )}
    </Space>
  );
};

export default Language;
